export default {
  "content": "<path d=\"M14.07 16.366h-1.86V14.35H8.25v-1.5l3.324-5.1h2.508v4.992h1.356v1.608H14.07v2.016zm-3.972-3.624h2.064V9.538l-2.064 3.204z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.929 4.928c3.905-3.905 10.237-3.905 14.142 0 3.905 3.906 3.905 10.238 0 14.143-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.906-10.237 0-14.143zm12.728 1.415A8.001 8.001 0 106.343 17.659 8.001 8.001 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};